<qr-overlay-topbar (close)="close.emit()"
  >Solicitud de Update de Reservas</qr-overlay-topbar
>
<div class="container">
  <div class="container__inputs">
    <div class="container__item-input">
      <p>Para:</p>
      <qr-input
        [config]="inputString"
        [value]="workEmailValue"
        (valueChange)="changeInputTo($event)"
      ></qr-input>
    </div>
    <div class="container__item-input">
      <p>CC:</p>
      <qr-input
        [config]="inputString"
        [value]="ccValue"
        (valueChange)="changeInputCc($event)"
      ></qr-input>
    </div>
    <div class="container__item-input">
      <p>Asunto:</p>
      <qr-input
        [config]="inputString"
        [value]="subjectValue"
        (valueChange)="changeInputSubject($event)"
      ></qr-input>
    </div>
  </div>
  <div class="container__body">
    <qr-textarea
      [config]="textArea"
      [value]="textAreaValue"
      (valueChange)="textareaChange($event)"
    ></qr-textarea>
  </div>
  <div class="container__footer">
    <qr-button [config]="buttonCancel" (click)="close.emit()"></qr-button>
    <qr-button [config]="buttonConfirm" (click)="requestSimple()"></qr-button>
  </div>
</div>
